import Vue from 'vue';
const {trimContent} = require('../../../shared/discussionText');
export const discussionEvents = new Vue();
let client;
const drafts = new Map();
let identity = null;
function sessionIdentity() {
    const token = localStorage.getItem('token');
    if (!token) return '';
    try { const data = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/'))); return `${data.company}:${data.userId || data.user_id || data.id}`; }
    catch (e) { return token; }
}
export function routeContext(route) {
    const path = route && route.path || '';
    if (/^\/tasks\/new$/.test(path)) return {type: 'task', id: 'new'};
    const match = path.match(/^\/(requests\/delete-shift-report|requests|tasks|objects|reports)\/(\d+)$/);
    if (match) return {type: {'requests/delete-shift-report': 'legacy', requests: 'request', tasks: 'task', objects: 'object', reports: 'report'}[match[1]], id: Number(match[2])};
    return null;
}
export function contextKey(ctx) { return ctx && ctx.id ? `${ctx.type}:${ctx.id}` : ''; }
export function registerDraft(vm) { drafts.set(vm._uid, vm); return () => drafts.delete(vm._uid); }
export function apiClient() { return client; }
export function contentFields(value, prefix = '', output = []) {
    if (!value || typeof value !== 'object' || prefix.length > 180) return output;
    Object.keys(value).filter(key => key !== '_discussion').forEach(key => {
        const path = prefix ? `${prefix}.${key}` : key;
        if (typeof value[key] === 'string' && /^(description|text|value|body|comment|reason|reason_text|cause|.*_comment|.*_reason)$/.test(key)) output.push({path, text: value[key]});
        else if (value[key] && typeof value[key] === 'object') contentFields(value[key], path, output);
    });
    return output;
}
function apiContext(config) {
    const url = String(config.url || '');
    if (String(config.method).toLowerCase() === 'post' && /\/(requests\/items|tasks-management)\/?$/.test(url)) return {type: url.includes('/requests/') ? 'request' : 'task', id: 'new'};
    const task = url.match(/\/tasks-management\/(\d+)\/?$/); if (task) return {type: 'task', id: Number(task[1])};
    for (const [type, re] of [['request', /\/requests\/items\/(\d+)(?:\/|$)/], ['object', /\/objects\/unified\/(\d+)(?:\/|$)/], ['report', /\/reports\/(\d+)(?:\/|$)/], ['timesheet', /\/timesheets\/(\d+)(?:\/|$)/]]) {
        const match = url.match(re); if (match) return {type, id: Number(match[1])};
    }
    const data = config.data || {};
    if (/\/tasks-management\/comments/.test(url)) return {type: 'task', id: Number(data.taskId || data.task && data.task.id)};
    if (/\/requests\/delete-shift-report\/comments/.test(url)) return {type: 'legacy', id: Number(data.requestId || data.request && data.request.id)};
    return null;
}
export function installDiscussions(api) {
    client = api;
    api.interceptors.request.use(config => {
        const current = sessionIdentity();
        if (identity !== null && identity !== current) { pendingReplies.clear(); discussionEvents.$emit('reset'); }
        identity = current;
        if (!['post', 'put', 'patch'].includes(String(config.method).toLowerCase()) || !config.data || typeof config.data !== 'object' || config.data instanceof FormData) return config;
        const ctx = apiContext(config);
        if (!contextKey(ctx)) return config;
        const metadata = [], editors = [];
        contentFields(config.data).forEach(field => {
            const matching = Array.from(drafts.values()).filter(vm => contextKey(vm.currentContext) === contextKey(ctx)
                && String(vm.value || '').trim() === field.text.trim() && (!vm.field || vm.field === field.path));
            if (!matching.length || !field.text.trim()) return;
            const options = matching.map(vm => {
                const normalized = trimContent(String(vm.value || ''), vm.mentions);
                return {path: field.path, text: normalized.text, mentions: normalized.mentions, reply_to: vm.reply || null};
            });
            if (options.some(option => JSON.stringify(option) !== JSON.stringify(options[0]))) throw new Error('В двух открытых полях одинаковый текст с разными упоминаниями. Закройте лишний редактор.');
            if (matching.some(vm => vm.enabled)) metadata.push(options[0]);
            matching.forEach(vm => { if (!editors.some(row => row.id === vm._uid)) editors.push({id: vm._uid, text: vm.value}); });
        });
        if (editors.length) {
            if (metadata.length) config.data = {...config.data, _discussion: metadata};
            config.discussionEditors = editors;
            config.ignoreModal = true;
            editors.forEach(row => { const vm = drafts.get(row.id); vm.pending = true; vm.error = ''; });
        }
        return config;
    });
    const finish = (config, error) => (config && config.discussionEditors || []).forEach(row => {
        const vm = drafts.get(row.id);
        if (!vm) return;
        vm.pending = false;
        if (error) vm.error = error.response && error.response.data && (error.response.data.message || error.response.data.msg) || 'Не удалось сохранить. Текст сохранён в поле, повторите попытку.';
        else if (vm.value === row.text) { vm.$emit('saved'); if (vm.primary && !vm.deferClear) vm.clear(); }
    });
    api.interceptors.response.use(response => { finish(response.config); discussionEvents.$emit('saved', response.config); return response; }, error => { finish(error.config, error); return Promise.reject(error); });
}
let reads = [], readTimer;
export function readMessage(message_ref, text, context, author_id, all_parts = false) {
    return new Promise((resolve, reject) => {
        reads.push({message_ref, text, context, author_id, all_parts, resolve, reject});
        if (readTimer) return;
        readTimer = setTimeout(async () => {
            readTimer = null; const batch = reads.splice(0); 
            for (let offset = 0; offset < batch.length; offset += 50) {
                const chunk = batch.slice(offset, offset + 50);
                const session = sessionIdentity();
                try {
                    const {data} = await client.post('/api/discussions/messages/read', {messages: chunk.map(row => ({message_ref: row.message_ref, text: row.text, context: row.context, author_id: row.author_id, all_parts: row.all_parts}))}, {ignoreModal: true});
                    chunk.forEach((row, index) => row.resolve(session === sessionIdentity() ? data.items[index] || {unavailable: true} : {unavailable: true}));
                } catch (e) { chunk.forEach(row => row.reject(e)); }
            }
        }, 0);
    });
}
export const discussionContextMixin = {
    inject: {providedDiscussionContext: {from: 'discussionContext', default: null}},
    props: {context: {type: Object, default: null}},
    computed: {currentContext() { return this.context || (this.providedDiscussionContext && this.providedDiscussionContext()) || routeContext(this.$route); }}
};
export const discussionFeedMixin = {
    inject: {discussionContext: {default: null}},
    mounted() {
        this._discussionOpen = ctx => {
            const current = this.discussionContext ? this.discussionContext() : routeContext(this.$route);
            if (contextKey(ctx) !== contextKey(current)) return;
            if ('showAddComment' in this) this.showAddComment = true;
            if ('showForm' in this) this.showForm = true;
            if ('activeSection' in this) this.activeSection = 'comments';
        };
        discussionEvents.$on('open-editor', this._discussionOpen);
        this._discussionReveal = ref => {
            const current = this.discussionContext ? this.discussionContext() : routeContext(this.$route);
            if (contextKey({type: ref.context_type, id: ref.context_id}) !== contextKey(current)) return;
            if ('activeSection' in this) this.activeSection = ref.source_type.endsWith('_history') ? 'history' : 'comments';
        };
        discussionEvents.$on('reveal-message', this._discussionReveal);
    },
    beforeDestroy() { discussionEvents.$off('open-editor', this._discussionOpen); discussionEvents.$off('reveal-message', this._discussionReveal); }
};
export const pendingReplies = new Map();
export function replyTo(ctx, message, start, length, origin) {
    const modal = origin && origin.closest('.modal');
    const target = modal && Array.from(drafts.values()).find(vm => vm.enabled && vm.$el.closest('.modal') === modal && !vm.$attrs.disabled && contextKey(vm.currentContext) === contextKey(ctx));
    pendingReplies.set(contextKey(ctx), {message_ref: message.message_ref, text_hash: message.text_hash, start, length,
        quote: message.body.slice(start || 0, length == null ? undefined : start + length), author_name: message.author_name, editor_id: target && target._uid});
    if (!target) discussionEvents.$emit('open-editor', ctx);
    Vue.nextTick(() => discussionEvents.$emit('reply', ctx, target && target._uid));
}
